import axios from 'axios'

export default{
    namespaced: true,

    state: {
        //
    },

    getters: {
        //
    },

    mutations: {
       //
    },

    actions: {
        getAttendanceRecords({ rootGetters }){
            const url = '/api/student-attendance/' + rootGetters['auth/getUserID'];
            console.log(url)
            return axios.get(url);
        }
    },
}